<template>
    <BaseDialog 
        :max_width="'80%'"
        :dialog="data.dialog"
        title="Tutorial"
        v-on:close_dialog="$emit('close_dialog')"
    >
    <v-textarea height="60vh" dense outlined readonly class="subtitle-1" v-model="data.message"></v-textarea>
    <template v-slot:action>
        <div class="d-flex align-center justify-center my-4">
          <v-btn @click="$emit('close_dialog')" text>chiudi</v-btn>
        </div>
    </template>        
    </BaseDialog>
</template>

<script>
import BaseDialog from './BaseDialog'
export default {
    components: {BaseDialog},
    props: ['data'],
}
</script>

<style>

</style>
